// components/profile/ChangePasswordModal.jsx
import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TextInput from "components/TextInput";
import CommonModal from "components/CommonModal";
import { changePassword } from "api/authService";
import { toast } from "react-toastify";

// Validation schema
const schema = yup.object().shape({
  oldPassword: yup.string().required("Old password is required"),
  newPassword: yup
    .string()
    .required("New password is required")
    .min(6, "Password must be at least 6 characters"),
  confirmNewPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm new password is required"),
});

const ChangePasswordModal = ({ show, onClose }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [changePasswordLoading, setChangePasswordLoading] = useState(false);

  const handleChangePassword = async (data) => {
    try {
      setChangePasswordLoading(true);
      const { oldPassword, newPassword } = data;
      const res = await changePassword({ oldPassword, newPassword });

      if (res.success) {
        toast.success(res.message || "Password changed successfully");
        reset();
        onClose();
      } else {
        toast.error(res.message || "Something went wrong.");
      }
    } catch (err) {
      console.error("Change password error:", err);
      toast.error("Failed to change password");
    } finally {
      setChangePasswordLoading(false);
    }
  };

  return (
    <CommonModal
      title={"Change Password?"}
      
      para={
        "Update your password to keep your account secure. Enter your current password, choose a new one, and confirm the change."
      }
      show={show}
      onClose={onClose}
      body={
        <form onSubmit={handleSubmit(handleChangePassword)} className="mt-4">
          <TextInput
            labelText="Old Password"
            type="password"
            placeholder="Enter old password"
            errorMessage={errors.oldPassword?.message}
            {...register("oldPassword")}
          />
          <TextInput
            labelText="New Password"
            type="password"
            placeholder="Enter new password"
            errorMessage={errors.newPassword?.message}
            {...register("newPassword")}
          />
          <TextInput
            labelText="Confirm New Password"
            type="password"
            placeholder="Enter confirm new password"
            errorMessage={errors.confirmNewPassword?.message}
            {...register("confirmNewPassword")}
          />
          <Button
            type="submit"
            variant="info"
            className="w-100 mt-4 border-radius-100 d-flex justify-content-center align-items-center"
            disabled={changePasswordLoading}
          >
            {changePasswordLoading ? (
            <Spinner animation="border" size="sm" />
            ) : (
              "Update"
            )}
          </Button>
        </form>
      }
    />
  );
};

export default ChangePasswordModal;
